exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".EvidenceGroup-module__wrapper___2qkdA .EvidenceGroup-module__title___3sRHf{display:grid;grid-auto-flow:column;justify-content:start;gap:.5rem;margin-bottom:1rem}.EvidenceGroup-module__wrapper___2qkdA .EvidenceGroup-module__evidence___WZz-a{display:grid;grid-template-columns:repeat(auto-fill,minmax(250px,1fr));gap:1rem}", ""]);

// exports
exports.locals = {
	"wrapper": "EvidenceGroup-module__wrapper___2qkdA",
	"title": "EvidenceGroup-module__title___3sRHf",
	"evidence": "EvidenceGroup-module__evidence___WZz-a"
};